/* =================================================================

  ページ読み込み時のアンカー位置補正

================================================================= */

export const anchorOffset = function () {
  const scrollWithOffset = () => {
    const header = document.querySelector(".js-header");
    const headerHeight = header ? header.offsetHeight : 0;

    const hash = location.hash;
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: "instant", // 即時移動
    });
  };

  // ページ読み込み時
  window.addEventListener("load", scrollWithOffset);

  // 同一ページ内リンク（ハッシュ変更）にも対応
  window.addEventListener("hashchange", function () {
    // hashchange は即座に計算するとズレることがあるので少し遅延させる
    setTimeout(scrollWithOffset, 1);
  });
};
